
import DataGrid, {
    Column,
    FilterRow,
    HeaderFilter, Pager,
    Paging, Selection, Sorting
} from 'devextreme-react/data-grid';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import React, { useCallback, useEffect, useReducer, useRef, useState } from 'react';
import { Transition } from 'semantic-ui-react';

import { hoSoSurveyApi } from '../../api/hoSoSurveyApi';
import { DangerButton, DefaultButton, PrimaryButton } from "../../components/editor/button";
import { HoSoStatusSelectionModal } from "../../components/ho-so-status-selection-modal";
import { HoSoStatusSummary } from '../../components/ho-so-status-summary';
import { useCommonContext } from '../../contexts/common';
import { showNotify } from '../../helpers/toast';
import { HoSoSurveyModal } from './detail-modal';
import { hoSoSurveyActionTypes, hoSoSurveyIniState, hoSoSurveyReducer, hoSoSurveyStatus } from './HoSoSurveyReducer';
const HoSoSurveyPage = () => {
    const { canAccessTo, translate } = useCommonContext();
    const [state, dispatch] = useReducer(hoSoSurveyReducer, hoSoSurveyIniState);
    const [refreshCount, setRefreshCount] = useState(0);
    const {
        ts_hoso_surveys,
        ts_hoso_survey_status_id,
        ts_hoso_survey_selected_ids,
        is_show_update_status_model,
        is_show_detail_modal,
        status,
        ts_hoso_survey_editing_id
    } = state;
    const grid = useRef(null);
    useEffect(() => {
        if (status == hoSoSurveyStatus.isLoading) {
            grid.current.instance.beginCustomLoading();
        } else {
            grid.current.instance.endCustomLoading();
        }
    }, [status]);
    useEffect(() => {
        handleLoadHoSo();
    }, [ts_hoso_survey_status_id])
    const handleLoadHoSo = async () => {
        setRefreshCount(refreshCount + 1);
        dispatch({ type: hoSoSurveyActionTypes.BEGIN_LOAD_HOSO });
        const res = await hoSoSurveyApi.SelectAll(ts_hoso_survey_status_id);
        if (res.is_success) {
            // console.log({
            //     dataSource: res.data
            // });
            dispatch({ type: hoSoSurveyActionTypes.SUCCESS_LOAD_HOSO, payload: res.data })
        } else {
            showNotify({ text: res.message, type: 'error' });
            dispatch({ type: hoSoSurveyActionTypes.ERROR_LOAD_HOSO })
        }
    }
    const handleStatusFilterChanged = useCallback((ts_hoso_survey_status_id) => {
        dispatch({ type: hoSoSurveyActionTypes.CHANGE_FILTER_STATUS_ID, payload: ts_hoso_survey_status_id })
    }, [dispatch])
    const handleUpdateStatus = async (ts_hoso_survey_status_id, ghi_chu) => {
        const res = await hoSoSurveyApi.UpdateStatus({
            ts_hoso_survey_ids: ts_hoso_survey_selected_ids,
            ts_hoso_survey_status_id,
            ghi_chu
        });
        if (res.is_success) {
            handleLoadHoSo();
            showNotify({ text: res.message, type: 'success' });
            dispatch({ type: hoSoSurveyActionTypes.CLOSE_UPDATE_STATUS_MODAL })
        } else {
            showNotify({ text: res.message, type: 'error' });
        }

    }
    const commandCellRender = (cell) => {
        return <a id={`btnEdit${cell.data.id}`}><i onClick={() => {
            dispatch({ type: hoSoSurveyActionTypes.SET_HOSO_EDITING_ID, payload: cell.data.id });
            dispatch({ type: hoSoSurveyActionTypes.SHOW_DETAIL_MODAL })
        }} className="cmd-edit-icon fas fa-edit"></i></a>
    }
    return (
        <>
            <Transition
                animation="scale"
                visible={true}
                duration={200}
                transitionOnMount={true}
            >
                <div>
                    <div className="row">
                        <div className="col-md-12 padding-top-1rem padding-left-1rem padding-right-1rem">
                            <Toolbar className="bg-background">
                                <Item
                                    location="before"
                                    render={() => {
                                        return <h3>{translate('Danh sách Hồ sơ')}</h3>;
                                    }}
                                />
                                {ts_hoso_survey_selected_ids.length <= 0 && (
                                    <Item
                                        location="after"
                                        render={() => {
                                            return (
                                                <PrimaryButton text={"Thêm mới hồ sơ"} onClick={() => {
                                                    dispatch({ type: hoSoSurveyActionTypes.SHOW_DETAIL_MODAL })
                                                }} />
                                            );
                                        }}
                                    />
                                )}
                                {ts_hoso_survey_selected_ids.length <= 0 && (
                                    <Item
                                        location="after"
                                        render={() => {
                                            return (
                                                <PrimaryButton
                                                    disabled={true}
                                                    text={"Import hồ sơ"} onClick={() => {
                                                        dispatch({ type: hoSoSurveyActionTypes.SHOW_DETAIL_MODAL })
                                                    }} />
                                            );
                                        }}
                                    />
                                )}
                                {ts_hoso_survey_selected_ids.length > 0 && (
                                    <Item
                                        location="after"
                                        render={() => {
                                            return (
                                                <DangerButton text={`Chuyển trạng thái (${ts_hoso_survey_selected_ids.length})`} onClick={() => {
                                                    dispatch({ type: hoSoSurveyActionTypes.SHOW_UPDATE_STATUS_MODAL })
                                                }} />
                                            );
                                        }}
                                    />
                                )}
                                <Item
                                    location="after"
                                    render={() => {
                                        return (
                                            <DefaultButton icon={"fas fa-file-excel"} text="Xuất Excel" onClick={() => {
                                                grid.current.instance.exportToExcel();
                                            }} />
                                        );
                                    }}
                                />
                            </Toolbar>
                        </div>
                        <div className='col-md-12'>
                            <HoSoStatusSummary refreshCount={refreshCount} onSelectionChanged={handleStatusFilterChanged} />
                        </div>
                        <div className="col-md-12">
                            <DataGrid
                                noDataText={translate('Không có dữ liệu')}
                                ref={grid}
                                keyExpr="id"
                                dataSource={ts_hoso_surveys}
                                columnHidingEnabled={false}
                                columnAutoWidth={true}
                                showBorders={true}
                                showColumnLines={false}
                                showRowLines={false}
                                rowAlternationEnabled={true}
                                allowColumnResizing={true}
                                columnResizingMode={'nextColumn'}
                                hoverStateEnabled={true}
                                focusedRowEnabled={false}
                                height={window.innerHeight - 150}
                                onSelectionChanged={({ selectedRowKeys }) => {
                                    dispatch({ type: hoSoSurveyActionTypes.CHANGE_SELECTED_IDS, payload: selectedRowKeys })
                                }}
                            >
                                <Selection mode="multiple" />
                                <Column dataField={"id"} caption="#Id" width={100} />
                                <Column caption="Sửa" width={100} alignment="center" cellRender={commandCellRender} />
                                <Column dataField={"ten_chien_dich"} caption="Chiến dịch" />
                                <Column dataField={"nam_hoc"} caption="Năm học" />
                                <Column dataField={"ho_ten"} caption="Họ tên" />
                                <Column dataField={"ts_hoso_survey_status_name"} caption="Trạng thái" />
                                <Column dataField={"gioi_tinh"} caption="Giới tính" />
                                <Column dataField={"ngay_sinh"} caption="Ngày sinh" dataType={"date"} format={"dd/MM/yyyy"} />
                                <Column dataField={"dien_thoai_lien_he"} caption="Điện thoại" />
                                <Column dataField={"nguoi_lien_he"} caption="Người liên  hệ" />
                                <Column dataField={"ghi_chu"} caption="Ghi chú" />
                                <Column dataField={"truong_dang_hoc"} caption="Trường đang học" />
                                <Column dataField={"nguon_du_lieu"} caption="Nguồn dữ liệu" />
                                <Sorting mode="multiple" />
                                <Paging defaultPageSize={50} />
                                <FilterRow
                                    visible={true}
                                    showOperationChooser={true}
                                    resetOperationText={false}
                                    operationDescriptions={'contains'}
                                />
                                <HeaderFilter visible={true} />
                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 20, 50, 200, 500]}
                                    infoText={`${translate('Trang')} {0} /{1} ({2} ${translate(
                                        'dòng'
                                    )})`}
                                    showInfo={true}
                                />
                            </DataGrid>
                        </div>
                        {is_show_update_status_model && <HoSoStatusSelectionModal
                            onCancel={() => { dispatch({ type: hoSoSurveyActionTypes.CLOSE_UPDATE_STATUS_MODAL }) }}
                            onSelected={handleUpdateStatus}
                        />}
                        {is_show_detail_modal && <HoSoSurveyModal
                            id={ts_hoso_survey_editing_id}
                            onCancel={() => {
                                dispatch({ type: hoSoSurveyActionTypes.CLOSE_DETAIL_MODAL })
                            }}
                            onSuccess={() => {
                                dispatch({ type: hoSoSurveyActionTypes.CLOSE_DETAIL_MODAL })
                                handleLoadHoSo();
                            }}
                        />}
                    </div>
                </div>
            </Transition>


        </ >
    );
};

export default HoSoSurveyPage;